import { render } from "./inspectionServer.vue?vue&type=template&id=6ccdd262&scoped=true"
import script from "./inspectionServer.vue?vue&type=script&lang=js"
export * from "./inspectionServer.vue?vue&type=script&lang=js"

import "./inspectionServer.vue?vue&type=style&index=0&id=6ccdd262&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ccdd262"

export default script